import { Route, Routes } from "react-router-dom";
import ContactFormVerificationModule from "./";

const ContactFormVerificationRoute = () => {
  return (
    <Routes>
      <Route path="/:key" element={<ContactFormVerificationModule />} />
      <Route path="/*" element={<ContactFormVerificationModule />} />
    </Routes>
  );
};

export default ContactFormVerificationRoute;
